module.exports = __webpack_public_path__ + "img/T1C_xs_002.43c7abdb.png";